import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'react-icheck'
import { pipe, path } from 'ramda'
import withTooltip from 'components/form/with-tooltip'

export const CheckboxField = ({
  input: { value, onChange },
  label,
  disabled,
  className,
  id
}) => (
  <Checkbox
    id={id}
    checkboxClass={className}
    checked={Boolean(value)}
    className={className}
    // passing onChange directly causes the value to be '' when its false
    onChange={pipe(path(['target', 'checked']), onChange)}
    label={label}
    disabled={disabled}
  />
)

CheckboxField.propTypes = {
  input: PropTypes.any,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string
}

export default withTooltip(CheckboxField)



// WEBPACK FOOTER //
// ./src/components/form/checkbox/index.js